(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.IBBabOfferV2 = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var VERSION = 'ib-bab-offer-v2';

  function whole(value, fallback) {
    var number = Number(value);
    if (!Number.isFinite(number)) return fallback || 0;
    return Math.max(0, Math.floor(number));
  }

  function tierPercent(boxes, kind) {
    boxes = whole(boxes, 0);
    if (boxes >= 4) return kind === 'sub' ? 18 : 15;
    if (boxes === 3) return kind === 'sub' ? 12 : 10;
    if (boxes === 2) return kind === 'sub' ? 6 : 5;
    return 0;
  }

  function giftForBoxes(boxes) {
    boxes = whole(boxes, 0);
    return {
      glasses: boxes >= 3 ? 2 : (boxes >= 2 ? 1 : 0),
      tshirt: boxes >= 4,
      freeDelivery: boxes >= 2
    };
  }

  function normalizeLine(line, index) {
    line = line || {};
    var quantity = whole(line.quantity, 0);
    var slots = Math.max(1, whole(line.slotsPerUnit, 1));
    var pricePence = whole(line.pricePence, 0);
    var productClass = line.class === 'limited' ? 'limited' : (line.class === 'core' ? 'core' : 'other');
    return {
      id: String(line.id || ('line-' + index)),
      quantity: quantity,
      slotsPerUnit: slots,
      boxCount: quantity * slots,
      class: productClass,
      subscriptionEligible: line.subscriptionEligible === true,
      oneTimeDiscountEligible: line.oneTimeDiscountEligible === true,
      pricePence: pricePence
    };
  }

  function compute(input) {
    input = input || {};
    var mode = input.mode === 'sub' ? 'sub' : 'otp';
    var lines = Array.isArray(input.lines) ? input.lines.map(normalizeLine).filter(function (line) {
      return line.quantity > 0 && line.class !== 'other';
    }) : [];

    var qualifyingBoxes = 0;
    var recurringCoreBoxes = 0;
    var oneTimeCoreBoxes = 0;
    lines.forEach(function (line) {
      qualifyingBoxes += line.boxCount;
      if (line.class !== 'core') return;
      if (mode === 'sub' && line.subscriptionEligible) recurringCoreBoxes += line.boxCount;
      else if (mode === 'otp' && line.oneTimeDiscountEligible) oneTimeCoreBoxes += line.boxCount;
    });

    var recurringPercent = tierPercent(recurringCoreBoxes, 'sub');
    var oneTimePercent = tierPercent(oneTimeCoreBoxes, 'otp');
    var subtotalPence = 0;
    var finalPence = 0;
    var lineTotals = lines.map(function (line) {
      var unitWas = line.pricePence;
      var unitNow = unitWas;
      var treatment = 'full-price';
      if (line.class === 'core' && mode === 'sub' && line.subscriptionEligible) {
        var sellingPlanUnit = Math.ceil(unitWas * 0.85);
        unitNow = Math.round(sellingPlanUnit * (1 - recurringPercent / 100));
        treatment = 'recurring-core';
      } else if (line.class === 'core' && mode === 'otp' && line.oneTimeDiscountEligible) {
        unitNow = Math.round(unitWas * (1 - oneTimePercent / 100));
        treatment = 'one-time-core';
      } else if (line.class === 'limited') {
        treatment = 'limited-full-premium';
      }
      var was = unitWas * line.quantity;
      var now = unitNow * line.quantity;
      subtotalPence += was;
      finalPence += now;
      return {
        id: line.id,
        class: line.class,
        treatment: treatment,
        quantity: line.quantity,
        boxes: line.boxCount,
        unitWasPence: unitWas,
        unitNowPence: unitNow,
        wasPence: was,
        nowPence: now,
        savingsPence: was - now
      };
    });

    var gift = giftForBoxes(qualifyingBoxes);
    return {
      version: VERSION,
      mode: mode,
      qualifyingBoxes: qualifyingBoxes,
      recurringCoreBoxes: recurringCoreBoxes,
      oneTimeCoreBoxes: oneTimeCoreBoxes,
      recurringPercent: recurringPercent,
      oneTimePercent: oneTimePercent,
      glasses: gift.glasses,
      tshirt: gift.tshirt,
      freeDelivery: gift.freeDelivery,
      lineTotals: lineTotals,
      subtotalPence: subtotalPence,
      finalPence: finalPence,
      savingsPence: subtotalPence - finalPence
    };
  }

  return {
    VERSION: VERSION,
    compute: compute,
    tierPercent: tierPercent,
    giftForBoxes: giftForBoxes
  };
});
